import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.IpBlocklist
const label = visitFilterLabelMap[key]

export const ipBlocklistColumn = () =>
  columnHelper.display({
    id: 'ipBlocklist',
    header: 'IP Blocklist',
    cell: ({ row }) => {
      const ipBlocklist = row.original.ip_blocklist

      if (ipBlocklist == null) {
        return <Unavailable />
      }

      // The format is { "attack_source": false, "tor_node": true, ... }
      const result = Object.values(ipBlocklist).some((v) => v === true)

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
